import { z } from 'zod';

export const userConfigSchema = z.object({
  ai_model: z.enum(['mistral', 'gemini', 'llava', 'scaleway-pixtral']),
  default_prompt: z.boolean(),
  custom_prompt: z.string(),
  show_reader: z.boolean(),
  theme_preference: z.enum(['system', 'light', 'dark']).catch('system'),
});

export type UserConfig = z.infer<typeof userConfigSchema>;

export const useUserConfig = (): Ref<UserConfig | null> =>
  useState('userConfig', () => null);

export const loadUserConfig = async (): Promise<void> => {
  const result = await useFetchAPI('/api/user/config');
  if (result?.data) {
    useUserConfig().value = result.data.value;
  }
};

export const saveUserConfig = async (): Promise<void> => {
  await useFetchAPI('/api/user/config', {
    method: 'PUT',
    body: useUserConfig().value,
  });
};
